@if (autoFocus === false) {
    <button style="position: absolute; left: -9999px; opacity: 0;" aria-hidden="true"></button>
}
<div class="modal-header">
	<h4 class="modal-title">{{title}}</h4>
	<button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="close()"></button>
</div>
<div class="modal-body">
@for (item of injectContent; track item) {
    @if (item.injectType === INJECT_TYPE.COMPONENT) {
        <ng-container *ngComponentOutlet="item.content; inputs: item.data"/>
    } @else {
        <ng-container [ngTemplateOutlet]="$any(item.content)" [ngTemplateOutletContext]="{ $implicit: item.data }" />
    }
}
</div>